<template>
  <div class="home">
    <header class="fixed-header">
      <img src="@/assets/portal/de-logo4.png" alt="LearnFast AI Logo" class="logo" />
      <nav>
        <div class="avatar-container" @click="toggleDropdown">
          <img
            src="@/assets/portal/default-avatar.svg"
            alt="User Avatar"
            class="avatar"
          />
          <div v-if="showDropdown" class="dropdown-menu">
            <template v-if="isLoggedIn">
              <p class="user-email">{{ userEmail }}</p>
              <a href="#" class="menu-item">我的账户</a>
              <a href="#" class="menu-item" @click.prevent="logout">退出登录</a>
            </template>
            <template v-else>
              <a
                href="#"
                class="menu-item"
                @click.prevent="showLoginForm = true"
                >登录</a
              >
              <!-- <a :href="website.ssoUrl + website.redirectUri">授权登录</a> -->
              <a href="#" class="menu-item">注册</a>
            </template>
          </div>
        </div>
      </nav>
    </header>
    <div class="background-container">
      <div class="blur-overlay"></div>
      <div class="content">
        <h1>数界探索AI：强大的AI企业财务管理方案</h1>
        <p>
          使用数界探索AI，您可以轻松管理企业的财务数据，包括财务报表、预算管理、成本控制等，帮助企业实现财务人工智能化转。
        </p>
        <a href="#" class="try-button group">
          <span class="icon-wrapper">
            <svg
              stroke="currentColor"
              fill="none"
              stroke-width="2"
              viewBox="0 0 24 24"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="arrow-icon"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </span>
          <span>立即免费试用</span>
        </a>
      </div>
    </div>
    <section class="features">
      <h2>数界探索AI 的核心功能</h2>
      <div class="feature-list">
        <div
          class="feature-item"
          v-for="(feature, index) in features"
          :key="index"
        >
          <div class="feature-content">
            <span class="feature-icon">
              <svg
                aria-hidden="true"
                viewBox="0 0 1024 1024"
                preserveAspectRatio="none"
                class="w-6 svg-fill-color"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M-0.003516 511.991511m60.339778-60.339779l103.316786-103.316786q60.339779-60.339779 120.679558 0l103.316786 103.316786q60.339779 60.339779 0 120.679558l-103.316786 103.316786q-60.339779 60.339779-120.679558 0l-103.316786-103.316786q-60.339779-60.339779 0-120.679558Z"
                ></path>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  opacity="0.6"
                  d="M287.997 223.990264m60.339779-60.339779l103.316786-103.316786q60.339779-60.339779 120.679557 0l103.316786 103.316786q60.339779 60.339779 0 120.679558l-103.316786 103.316786q-60.339779 60.339779-120.679557 0l-103.316786-103.316786q-60.339779-60.339779 0-120.679558Z"
                ></path>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M575.998247 511.99078m60.339779-60.339778l103.316786-103.316786q60.339779-60.339779 120.679557 0l103.316786 103.316786q60.339779 60.339779 0 120.679557l-103.316786 103.316786q-60.339779 60.339779-120.679557 0l-103.316786-103.316786q-60.339779-60.339779 0-120.679557Z"
                ></path>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  opacity="0.6"
                  d="M288.003979 800.007112m60.339779-60.339778l103.316786-103.316786q60.339779-60.339779 120.679557 0l103.316786 103.316786q60.339779 60.339779 0 120.679557l-103.316786 103.316786q-60.339779 60.339779-120.679557 0l-103.316786-103.316786q-60.339779-60.339779 0-120.679557Z"
                ></path>
              </svg>
            </span>
            <h3>{{ feature.title }}</h3>
            <vue3-markdown-it
              v-if="feature.isMarkdown"
              :source="feature.description"
            />
            <p v-else>{{ feature.description }}</p>
          </div>
          <div class="feature-images">
            <img
              v-for="(image, imgIndex) in feature.images"
              :key="imgIndex"
              :src="image"
              :alt="`${feature.title} image ${imgIndex + 1}`"
              :style="{ zIndex: feature.images.length - imgIndex }"
            />
          </div>
        </div>
      </div>
    </section>
    <!-- 添加新的 footer 部分 -->
    <footer class="site-footer">
      <div class="footer-content">
        <div class="footer-section">
          <h3>厦门南云网络科技有限公司</h3>
          <ul>
            <li><a href="#">关于我们</a></li>
            <li><a href="#">商务合作</a></li>
          </ul>
        </div>
        <div class="footer-section">
          <h3>我们的产品</h3>
          <ul>
            <li><a href="#">产品说明</a></li>
            <li><a href="#"></a></li>
          </ul>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="logo-section">
          <img
            src="@/assets/portal/de-logo.png"
            alt="LearnFast.AI Logo"
            class="footer-logo"
          />
          <!-- <span class="support-email">support@learnfast.ai</span> -->
        </div>
        <div class="copyright"><a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">闽ICP备19014985号-7</a></div>
      </div>
    </footer>

    <!-- 登录表单 -->
    <div v-if="showLoginForm" class="login-overlay">
      <div class="login-form">
        <h2>登录</h2>
        <form @submit.prevent="login">
          <div class="form-group">
            <label for="tenantId">租户ID</label>
            <input
              type="text"
              id="tenantId"
              v-model="loginForm.tenantId"
              required
            />
          </div>
          <div class="form-group">
            <label for="username">用户名</label>
            <input
              type="text"
              id="username"
              v-model="loginForm.username"
              required
            />
          </div>
          <div class="form-group">
            <label for="password">密码</label>
            <input
              type="password"
              id="password"
              v-model="loginForm.password"
              required
            />
          </div>
          <p v-if="loginError" class="error-message">{{ loginError }}</p>
          <button type="submit" class="login-button">登录</button>
        </form>
        <button class="close-button" @click="showLoginForm = false">×</button>
      </div>
    </div>
  </div>
</template>

<script>
import backgroundImage from "@/assets/portal/violet_bg_group.svg";
import Vue3MarkdownIt from "vue3-markdown-it";
import website from "@/config/website";
import axios from 'axios';
import md5 from 'md5';

export default {
  name: "HomePage",
  components: {
    Vue3MarkdownIt,
  },
  data() {
    return {
      website: website,
      backgroundImage: `url(${backgroundImage})`,
      features: [
        {
          title: "AI税法智能案例解读",
          description: `
智能税法咨询平台提供全面的税法搜索、解读和案例分析服务，支持广泛的税务问题覆盖。该平台使用人工智能技术来即时响应用户的税法查询，并提供详尽的解释和实际应用案例，帮助用户深入理解各种税法规定。

## 核心功能：

- **税法搜索与解读**：平台提供标准的税法查询和解读功能，覆盖各类税务问题，确保用户能够快速找到相关税法条款和规定。
- **实际应用案例分析**：通过展示具体的应用案例，平台帮助用户更好地理解税法如何在现实场景中运作，特别适用于个人纳税者和企业财务人员。
- **智能化互动**：平台通过智能化的互动，为用户提供更加高效和精准的税法解答，确保税务问题能够得到及时、准确的处理。
- **丰富的资源库**：平台集成了大量税法条文、政策解读和实际案例的资源库，用户可以随时访问，帮助他们提高处理税务问题的能力。

智能税法咨询平台极大地方便了用户对税法的学习与应用，使处理税务问题变得更加直接和高效，提升了用户应对税务挑战的。
          `,
          isMarkdown: true,
          images: [require("@/assets/portal/pd1.png"), require("@/assets/portal/pd1-1.png")],
        },
        {
          title: "生成式AI审计",
          description: `
这是一款采用尖端人工智能技术自动生成审计底稿的工具，专为提高审计工作的效率与精准度而设计。通过自动提取和整合来自多个数据源的关键信息，此工具大幅减少了手动数据处理的需求，确保了数据的全面性与最新性。

## 核心功能：

- **自动数据整合**：实时分析各类数据源，自动整合关键信息至审计底稿，保证信息的全面性和实时更新。
- **智能错误诊断与修正**：内置智能错误检测机制，能够识别并提出数据输入错误的修正建议，确保底稿数据的准确无误。
- **效率提升**：自动化复杂数据处理任务，大幅提升审计工作效率，使审计师能专注于更高阶的分析与决策。
- **直观操界面**：简洁易懂的用户界面，确保即使非技术背景的用户也能快速掌握，降低操作难度。
- **高度定制性**：支持底稿格式和内容的个性化定制，适应不同审计场景的需求，增强工具的适用性和灵活性。

该AI审计底稿工具不仅能显著升审计团队工作效率，还能增强审报告的整体质量和可信度，推动财务审计工作向数字化智能化的未来迈进。
          `,
          isMarkdown: true,
          images: [require("@/assets/portal/pd3.png")],
        },
        {
          title: "AI企业财务BP实训",
          description:
            "通过提供专业的BP课程和生动的案例教学，让学员由浅入深地掌握财务BP的核心技能。系统深度集成AI技术，支持学员与AI互动学习，提升学习效果。我们还推出了线下AI财务BP训练营，帮助学员深入理解财务BP的实际工作场景，并探索AI在财务工作中的巨大应用潜力。作为一款可以面向个人或机的SaaS服务系统，用户可以灵活自定义课程，通过AI的协助，轻松快速地编制个性化的教学内容，体验便捷、高效的课程设计流程。",
          isMarkdown: false,
          images: [require("@/assets/portal/pd3.png")],
        },
      ],
      isLoggedIn: false, // 初始状态设为未登录
      userEmail: "",
      showDropdown: false,
      showLoginForm: false,
      loginForm: {
        tenantId: "",
        username: "",
        password: "",
      },
      loginError: "",
    };
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    logout() {
      this.isLoggedIn = false;
      this.userEmail = "";
      this.showDropdown = false;
      // 这里可以添加其他退出登录相关的操作，比如清除本地存储、发送退出请求到服务器等
    },
    async login() {
      this.loginError = "";
      const { clientId, clientSecret } = website;
      const basicAuth = btoa(`${clientId}:${clientSecret}`);
      
      const params = new URLSearchParams();
      params.append('grant_type', 'password');
      params.append('scope', 'all');
      params.append('username', this.loginForm.username);
      params.append('password', md5(this.loginForm.password));

      try {
        const response = await axios.post('http://localhost/sc-auth/oauth/token', params, {
          headers: {
            'Authorization': `Basic ${basicAuth}`,
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });

        // 登录成功
        console.log('登录成功:', response.data);
        this.isLoggedIn = true;
        this.userEmail = this.loginForm.username;
        this.showLoginForm = false;
        this.showDropdown = false;
        // 清空表单
        this.loginForm = { tenantId: "", username: "", password: "" };
        
        // 这里可以保存token等信息
        // localStorage.setItem('token', response.data.access_token);
      } catch (error) {
        console.error('登录失败:', error);
        this.loginError = "登录失败，请检查您的用户名和密码。";
      }
    },
  },
};
</script>

<style scoped>
.home {
  display: flex;
  flex-direction: column;
  color: #333;
}

.background-container {
  background-image: v-bind(backgroundImage);
  background-size: 100% 100%;
  background-position: center top;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  padding-bottom: 50px;
  position: relative;
}

.blur-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  backdrop-filter: blur(5px);
  background-color: rgba(255, 255, 255, 0.3);
}

header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 1;
}

.logo {
  height: 40px;
  margin-left: 40px;
}

nav {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

nav a {
  margin-left: 20px;
  text-decoration: none;
  color: #333;
  transition: color 0.3s;
}

nav a:hover {
  color: #8a2be2; /* 紫色，与按钮颜色一致 */
}

.language {
  padding: 5px 10px;
  border-radius: 5px;
}

.language:hover {
  background-color: transparent;
}

.avatar-container {
  position: relative;
  margin-left: 20px;
  margin-right: 40px;
  cursor: pointer;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.content {
  text-align: center;
  max-width: 800px;
  margin: auto;
  padding: 20px 20px;
  position: relative;
  z-index: 1;
}

h1 {
  font-size: 3em;
  margin-bottom: 20px;
}

p {
  font-size: 1.2em;
  margin-bottom: 30px;
}

.try-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #8a2be2; /* 初始紫色背景 */
  color: white;
  border: none;
  padding: 10px 16px;
  font-size: 1em;
  font-weight: 600; /* 增加文字粗细 */
  border-radius: 9999px;
  cursor: pointer;
  transition: all 0.5s;
  text-decoration: none;
  height: 40px;
  box-sizing: border-box;
}

.try-button:hover {
  background-color: #000000; /* 悬停时变为黑色 */
  padding-left: 8px;
}

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white; /* 非悬停时为白色 */
  border-radius: 50%;
  width: 8px;
  height: 8px;
  transition: all 0.3s;
  overflow: hidden;
  margin-right: 8px;
}

.arrow-icon {
  opacity: 0;
  transform: translateX(-200%);
  width: 16px;
  height: 16px;
  transition: all 0.3s;
}

.try-button:hover .icon-wrapper {
  background-color: #8a2be2; /* 悬停时变为紫色，与按钮初始颜色一致 */
  width: 24px;
  height: 24px;
}

.try-button:hover .arrow-icon {
  opacity: 1;
  transform: translateX(0);
  color: white; /* 将箭头颜色改为白色，以便在紫色背景上更加明显 */
}

.try-button:active .arrow-icon {
  transform: rotate(-45deg);
}

.features {
  width: 100%;
  background-color: #ffffff;
  padding: 50px 0;
}

h2 {
  font-size: 2em;
  margin-bottom: 30px;
  text-align: center;
}

.feature-list {
  display: flex;
  flex-direction: column;
  gap: 50px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.feature-item {
  display: flex;
  align-items: center;
  background-color: #f6f3fd;
  border-radius: 10px;
  overflow: visible; /* 改为 visible 以显示溢出的图片部分 */
  margin-bottom: 30px; /* 增加底部间距 */
}

.feature-content {
  flex: 1;
  padding: 30px;
  position: relative;
  z-index: 2; /* 确保内容在图片之上 */
}

.feature-images {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px; /* 图片之间的间距 */
  padding: 20px;
}

.feature-images img {
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.feature-item:hover .feature-images img {
  transform: translateY(-5px);
}

/* 移除之前的定位样式 */
.feature-images img:nth-child(1),
.feature-images img:nth-child(2),
.feature-images img:nth-child(3) {
  position: static;
  top: auto;
  left: auto;
}

.feature-icon {
  position: absolute;
  top: 25px;
  left: 25px;
  width: 25px;
  height: 25px;
  color: #8a2be2; /* 添加颜色，使用紫色 */
}

.svg-fill-color {
  fill: currentColor; /* 使用当前文本颜色作为填充色 */
}

.feature-item h3 {
  font-size: 1.2em;
  margin-bottom: 15px;
}

.feature-item p {
  font-size: 1em;
}

.pin-icon {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 24px;
  height: 24px;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 10px;
  min-width: 200px;
  z-index: 10;
}

.avatar-container:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.user-email {
  font-size: 0.9em;
  color: #666;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.menu-item {
  display: block;
  padding: 8px 0;
  color: #333;
  text-decoration: none;
  transition: background-color 0.3s;
}

.menu-item:hover {
  background-color: #f5f5f5;
}

/* 在现有样式的末尾添加以下规则 */

.home,
.home * {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.home input,
.home textarea {
  user-select: text;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
}

.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  background-color: rgba(255, 255, 255, 0.01); /* 降低不透明度 */
  backdrop-filter: blur(3px); /* 稍微减少模糊程度 */
}

.background-container {
  padding-top: 60px; /* 保持这个样式以为固定的 header 腾出空间 */
}

/* 加新的 footer 样式 */
.site-footer {
  background-color: #1c1c1c;
  color: #ffffff;
  padding: 40px 0; /* 移除左右内边距 */
}

.footer-content {
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px; /* 添加左右内边距 */
}

.footer-section {
  flex: 1;
  margin-right: 20px;
}

.footer-section h3 {
  font-size: 1.2em;
  margin-bottom: 15px;
}

.footer-section ul {
  list-style-type: none;
  padding: 0;
}

.footer-section ul li {
  margin-bottom: 10px;
}

.footer-section ul li a {
  color: #ffffff;
  text-decoration: none;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
  padding: 20px 40px 0; /* 添加左右内边距，保持顶部内边距 */
  border-top: 1px solid #333;
  max-width: 1200px; /* 设置最大宽度 */
  margin: 40px auto 0; /* 居中并保持部边距 */
}

.logo-section {
  display: flex;
  align-items: center;
}

.footer-logo {
  width: 120px; /* 增加宽度 */
  height: auto; /* 自动调整高度以保持比例 */
  margin-right: 10px;
}

.company-name {
  font-weight: bold;
  margin-right: 10px;
}

.support-email {
  color: #999;
}

.copyright {
  color: #999;
}

.copyright a {
  color: #999;
  text-decoration: none;
}

.copyright a:hover {
  color: #ffffff;
}

/* 为Markdown内容添加一基本样式 */
.feature-item >>> ul,
.feature-item >>> ol {
  text-align: left;
  padding-left: 20px;
}

.feature-item >>> p {
  text-align: left;
}

.feature-item >>> strong {
  font-weight: bold;
}

/* 可能需要调整 Markdown 渲染的样式 */
.vue3-markdown-it {
  text-align: left;
}

.vue3-markdown-it h2 {
  font-size: 1.5em;
  margin-top: 1em;
  margin-bottom: 0.5em;
}

.vue3-markdown-it ul {
  padding-left: 20px;
}

.vue3-markdown-it li {
  margin-bottom: 0.5em;
}

.vue3-markdown-it strong {
  font-weight: bold;
}

.login-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
}

.login-form {
  background-color: white;
  padding: 30px; /* 增加内边距 */
  border-radius: 8px;
  width: 400px; /* 稍微减小宽度 */
  position: relative;
}

.login-form h2 {
  margin-bottom: 20px;
  text-align: center;
}

.form-group {
  margin-bottom: 20px; /* 增加底部间距 */
}

.form-group label {
  display: block;
  margin-bottom: 8px; /* 增加标签和输入框之间的间距 */
  font-weight: bold; /* 加粗标签文字 */
}

.form-group input {
  width: calc(100% - 24px); /* 减去左右padding的宽度 */
  padding: 10px 12px; /* 增加内边距，左右各12px */
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px; /* 设置字体大小 */
}

.login-button {
  width: 100%;
  padding: 12px; /* 增加按钮的内边距 */
  background-color: #8a2be2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px; /* 增加按钮字体大小 */
  font-weight: bold; /* 加粗按钮文字 */
}

.login-button:hover {
  background-color: #7a1dd1;
}

.close-button {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666; /* 设置颜色 */
}

.close-button:hover {
  color: #333; /* 悬停时改变颜色 */
}

.error-message {
  color: red;
  margin-bottom: 10px;
}
</style>
